import { createI18n } from 'vue-i18n'
import zhCn from './zhCN'
import en from './en'

export default createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  globalInjection: true,
  messages: {
    'zh-CN': zhCn,
    en
  }
})
